import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { DRACOLoader, GLTFLoader, MeshoptDecoder } from "three-stdlib";

import { getRouter } from "./router";

// Configure Draco decoder for static models
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.7/");

// Configure GLTFLoader with both decoders
GLTFLoader.prototype.setDRACOLoader(dracoLoader);
GLTFLoader.prototype.setMeshoptDecoder(MeshoptDecoder);

const root = document.querySelector("#root");
if (!root) {
	throw new Error("Root element not found");
}

const router = getRouter();

// https://bun.com/docs/bundler/hot-reloading#import-meta-hot-data
// oxlint-disable-next-line no-unsafe-call, no-unsafe-member-access
(import.meta.hot.data.root ??= createRoot(root)).render(
	<StrictMode>
		<RouterProvider router={router} />
	</StrictMode>,
);
